module.exports = __webpack_public_path__ + "img/confirm.d33d399a.png";